import { TopicReferenceSegment } from "@/shared/domain/skills/topicReference";

import styles from "./topicReferenceTokens.module.css";

/**
 * Segment kind → chip class for rendering `[[topic.field]]` references —
 * shared by the skill editor's highlight overlay and the markdown preview's
 * remarkTopicReferences plugin so both surfaces color a reference
 * identically. ``plain`` segments carry no class.
 */
export const TOPIC_SEGMENT_CLASS: Record<
  TopicReferenceSegment["kind"],
  string | undefined
> = {
  plain: undefined,
  bracket: styles.bracketToken,
  topic: styles.topicToken,
  topicUnknown: styles.topicTokenUnknown,
  field: styles.fieldToken,
};
